export default __webpack_public_path__ + "static/media/info-circle-danger.220ae75a.svg";